import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/hunkemoller.webp';
import screenshot_target from '../../../images/letterfunnel/gordonsmit.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Gordon Smit"
      firstname="Gordon"
      companyname="Hunkemöller"
      competition="Victoria's Secret en Intimissimi"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/gordonsmit.js